// AssignmentSearch.js
import React, {useCallback, useContext, useEffect, useMemo, useRef, useState} from "react";
import {
    Card,
    Table,
    Badge,
    Dropdown,
    Button,
    Form,
    Row,
    Col,
    Pagination,
    InputGroup, Spinner
} from "react-bootstrap";
import {fetchAssignmentsAdmin, fetchAssTypes} from "../../http/bookAPI";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EditAssignmentAdmin from "./EditAssignmentAdmin";
import { format, differenceInMinutes } from "date-fns";
import { enUS } from "date-fns/locale";
import {Context} from "../../index";
import AdminStaleAssignmentAudit from "./AdminStaleAssignmentAudit";

const GROUPED_ASS_TYPES = [
    { ids: [10, 14], label: "Paper Book BuyOut" },
    { ids: [11, 15], label: "Paper Book Search&BuyOut" },
    { ids: [18, 20], label: "Paper Book Verified Purchase" },
    { ids: [12, 16], label: "Paper Book Verified Purchase + Img" },
    { ids: [13, 17], label: "Paper Book Verified Purchase + Video" },
    { ids: [19, 21], label: "Paper Book VP Search&Buy" },
    { ids: [28, 29, 30, 31], label: "Make Helpful" },
];

const HIDDEN_ASS_TYPE_IDS = new Set([22, 23, 24, 25, 26, 27]);
const groupByAssTypeId = GROUPED_ASS_TYPES.reduce((acc, group) => {
    group.ids.forEach((id) => acc.set(id, group));
    return acc;
}, new Map());

const buildAssTypeOptions = (asstypes = []) => {
    const visibleTypes = asstypes
        .slice(0, 32)
        .filter((type) => !HIDDEN_ASS_TYPE_IDS.has(type.id));
    const visibleTypeIds = new Set(visibleTypes.map((type) => type.id));
    const renderedGroups = new Set();

    return visibleTypes.reduce((options, type) => {
        const group = groupByAssTypeId.get(type.id);
        if (!group) {
            options.push({
                ...type,
                filterValue: String(type.id),
                filterLabel: type.ass_type_name,
            });
            return options;
        }

        const groupKey = group.ids.join(",");
        if (renderedGroups.has(groupKey)) return options;

        const ids = group.ids.filter((id) => visibleTypeIds.has(id));
        if (!ids.length) return options;

        renderedGroups.add(groupKey);
        options.push({
            ...type,
            id: ids.join(","),
            assTypeIds: ids,
            ass_type_name: group.label,
            filterValue: ids.join(","),
            filterLabel: group.label,
        });
        return options;
    }, []);
};

const AssignmentSearch = ({
    externalFilter,
    onOpenBookAssignments,
    onOpenUserAuthorAssignments,
    onOpenUserReviewerAssignments,
}) => {
    const [status, setStatus] = useState("");
    const [checkStatus, setCheckStatus] = useState("");
    const [createDate, setCreateDate] = useState("");
    const [startDate, setStartDate] = useState("");
    const [publishDate, setPublishDate] = useState("");
    const [assignments, setAssignments] = useState([]);
    const [selectedAssignment, setSelectedAssignment] = useState(null);
    const [modalShow, setModalShow] = useState(false);
    const [message, setMessage] = useState("");
    const [ownerId, setOwnerId] = useState("");
    const [reviewerId, setReviewerId] = useState("");
    const [bookId, setBookId] = useState("");

    const [q, setQ] = useState("");
    const [assignmentId, setAssignmentId] = useState("");
    const [onlyWithLink, setOnlyWithLink] = useState(false);


    const [startDateTo, setStartDateTo] = useState("");
    const [publishDateTo, setPublishDateTo] = useState("");
    const [confirmDate, setConfirmDate] = useState("");   // Confirmed from
    const [confirmDateTo, setConfirmDateTo] = useState(""); // Confirmed to

    const [createDateTo, setCreateDateTo] = useState("");

    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(100);
    const [totalCount, setTotalCount] = useState(0);
    const [loading, setLoading] = useState(false);

    const [assTypes, setAssTypes] = useState([]);
    const [assTypeId, setAssTypeId] = useState("");
    const skipInitialAutoSearchRef = useRef(true);
    const skipNextAutoSearchRef = useRef(false);

    useEffect(() => {
        let alive = true;
        (async () => {
            try {
                const data = await fetchAssTypes();
                if (alive) setAssTypes(Array.isArray(data) ? data : []);
            } catch (e) {
                console.error("fetchAssTypes error:", e);
                setAssTypes([]);
            }
        })();
        return () => { alive = false; };
    }, []);

    const handleAssTypeChange = (event) => {
        const val = event.target.value;
        setAssTypeId(val);
    };

    const assTypeOptions = useMemo(() => buildAssTypeOptions(assTypes), [assTypes]);

    const [allAssignments, setAllAssignments] = useState([]);

    const statusOptions = [
        "NEW",
        "READING_ALL",
        "READING",
        "READING_RIDT",
        "READING_RE",
        "REPORTED_ALL",
        "REPORTED",
        "REPORTED_RFU",
        "REPORTED_RV",
        "REPORTED_EXP",
        "SUCCESS",
        "SUSPENDED"
    ];

    const checkStatusOptions = [
        "COMPLAINT",
        "REFUNDED",
        "REPORTED",
        "DECLINED",
        "AWAITING",
        "COMPLETE",
    ];

    const formatDateWithElapsedTime = (minutes) => {
        if (!minutes && minutes !== 0) return "N/A";
        const date = new Date(minutes * 60000);
        const now = new Date();
        const formattedDate = format(date, "dd-MMM", { locale: enUS });
        const diffMinutes = differenceInMinutes(now, date);
        if (diffMinutes < 0) return `${formattedDate} (Future)`;
        const days = Math.floor(diffMinutes / 1440);
        const hours = Math.floor((diffMinutes % 1440) / 60);
        return `${formattedDate} ${days}D ${hours}H`;
    };

      const toMinutesStartOfDay = (val) => {
        if (!val) return undefined;
        const d = new Date(val); // Р»РѕРєР°Р»СЊРЅР°СЏ РїРѕР»СѓРЅРѕС‡СЊ
        return Math.floor(d.getTime() / 60000);
    };
    const toMinutesEndOfDay = (val) => {
        if (!val) return undefined;
        const d = new Date(val);
        d.setHours(23, 59, 59, 999);
        return Math.floor(d.getTime() / 60000);
    };

     const buildQueryParams = (pageOverride) => {
        const params = {};
        if (status) params.assignment_status = status;
        if (checkStatus) params.check_status = checkStatus;
        if (ownerId) params.ownerId = ownerId;
        if (reviewerId) params.reviewer_id = reviewerId;
        if (bookId) params.bookId = bookId;
        if (assignmentId) params.assignment_id = assignmentId;
        if (q) params.q = q;
        if (assTypeId !== "") params.ass_type_id = assTypeId;

         if (onlyWithLink) params.only_with_link = 1;

        if (createDate) params.created_from = toMinutesStartOfDay(createDate);
        if (createDateTo) params.created_to = toMinutesEndOfDay(createDateTo);

        // Start (from/to)
        if (startDate) params.start_read_date_from = toMinutesStartOfDay(startDate);
        if (startDateTo) params.start_read_date_to = toMinutesEndOfDay(startDateTo);

        // Report (from/to)
        if (publishDate) params.publish_rev_date_from = toMinutesStartOfDay(publishDate);
        if (publishDateTo) params.publish_rev_date_to = toMinutesEndOfDay(publishDateTo);


        if (confirmDate) params.end_rev_date_from = toMinutesStartOfDay(confirmDate);
        if (confirmDateTo) params.end_rev_date_to = toMinutesEndOfDay(confirmDateTo);

        params.page = pageOverride ?? page;
        params.limit = limit;

        return params;
    };

    const loadAssignments = useCallback(async ({ pageOverride = 1, notify = false, paramsOverride = null } = {}) => {
        try {
            setLoading(true);
            const params = paramsOverride || buildQueryParams(pageOverride);
            const response = await fetchAssignmentsAdmin(params);


            if (response?.items && Number.isFinite(response?.count)) {
                setAllAssignments([]);
                setAssignments(response.items);
                setTotalCount(response.count);
                setPage(pageOverride);
                setMessage("");
                if (notify) {
                    toast.success(`${response.count} pcs of ${status || "All"} Assig's!`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                }
                return;
            }


            if (Array.isArray(response?.assignments) && response.assignments.length > 0) {
                setAllAssignments(response.assignments);
                setTotalCount(response.assignments.length);
                setPage(pageOverride);


                const firstSlice = response.assignments.slice(0, limit);
                setAssignments(firstSlice);
                setMessage("");
                if (notify) {
                    toast.success(`${response.assignments.length} assignments found`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                }
            } else {
                setAssignments([]);
                setAllAssignments([]);
                setTotalCount(0);
                setMessage(response?.message || "No assignments found");
                if (notify) {
                    toast.warning(response?.message || "No assignments found", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                }
            }
            setLoading(false);
        } catch (error) {
            setAssignments([]);
            setAllAssignments([]);
            setTotalCount(0);
            if (notify) {
                toast.error("Error fetching assignments", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            }
            console.error("Error fetching assignments:", error);
            setLoading(false);
        } finally {
            setLoading(false);
        }
    }, [
        status,
        checkStatus,
        ownerId,
        reviewerId,
        bookId,
        assignmentId,
        q,
        assTypeId,
        onlyWithLink,
        createDate,
        createDateTo,
        startDate,
        startDateTo,
        publishDate,
        publishDateTo,
        confirmDate,
        confirmDateTo,
        limit,
    ]);

    const applyFilter = async () => {
        await loadAssignments({ pageOverride: 1, notify: true });
    };

    const hasValue = (v) => !(v == null || (typeof v === "string" && v.trim() === ""));

    const hasActiveFilters = useMemo(() => ([
        status,
        checkStatus,
        ownerId,
        reviewerId,
        bookId,
        assignmentId,
        q,
        assTypeId,
        createDate,
        createDateTo,
        startDate,
        startDateTo,
        publishDate,
        publishDateTo,
        confirmDate,
        confirmDateTo,
    ].some(hasValue) || onlyWithLink), [
        status,
        checkStatus,
        ownerId,
        reviewerId,
        bookId,
        assignmentId,
        q,
        assTypeId,
        createDate,
        createDateTo,
        startDate,
        startDateTo,
        publishDate,
        publishDateTo,
        confirmDate,
        confirmDateTo,
        onlyWithLink,
    ]);

    useEffect(() => {
        if (skipInitialAutoSearchRef.current) {
            skipInitialAutoSearchRef.current = false;
            return;
        }

        if (skipNextAutoSearchRef.current) {
            skipNextAutoSearchRef.current = false;
            return;
        }

        if (!hasActiveFilters) {
            setAssignments([]);
            setAllAssignments([]);
            setTotalCount(0);
            setMessage("");
            setPage(1);
            return;
        }

        const timer = setTimeout(() => {
            loadAssignments({ pageOverride: 1, notify: false });
        }, 450);

        return () => clearTimeout(timer);
    }, [hasActiveFilters, loadAssignments]);

    useEffect(() => {
        const nextOwnerId = externalFilter?.ownerId ? String(externalFilter.ownerId) : "";
        const nextReviewerId = externalFilter?.reviewerId ? String(externalFilter.reviewerId) : "";
        const nextBookId = externalFilter?.bookId ? String(externalFilter.bookId) : "";
        if (!nextOwnerId && !nextReviewerId && !nextBookId) return;

        skipNextAutoSearchRef.current = true;
        setStatus("");
        setCheckStatus("");
        setCreateDate("");
        setCreateDateTo("");
        setStartDate("");
        setStartDateTo("");
        setPublishDate("");
        setPublishDateTo("");
        setConfirmDate("");
        setConfirmDateTo("");
        setOwnerId(nextOwnerId);
        setReviewerId(nextReviewerId);
        setBookId(nextBookId);
        setAssignmentId("");
        setQ("");
        setAssTypeId("");
        setOnlyWithLink(false);
        setAssignments([]);
        setAllAssignments([]);
        setTotalCount(0);
        setMessage("");
        setPage(1);

        const params = {
            page: 1,
            limit,
            ...(nextOwnerId ? { ownerId: nextOwnerId } : {}),
            ...(nextReviewerId ? { reviewer_id: nextReviewerId } : {}),
            ...(nextBookId ? { bookId: nextBookId } : {}),
        };
        loadAssignments({ pageOverride: 1, notify: false, paramsOverride: params });
    }, [externalFilter?.nonce, externalFilter?.ownerId, externalFilter?.reviewerId, externalFilter?.bookId, limit]);

    const resetFilters = () => {
        setStatus("");
        setStartDate("");
        setPublishDate("");
        setAssignments([]);
        setBookId("");
        setOwnerId("");
        setReviewerId("");
        setCreateDate("");
        setStartDate("");
        setPublishDate("");
        setCheckStatus("");
        setMessage("");
        setAssTypeId("");
        // NEW:
        setQ("");
        setAssignmentId("");
        setOnlyWithLink(false);
        setStartDateTo("");
        setPublishDateTo("");
        setConfirmDate("");
        setConfirmDateTo("");
        setCreateDateTo("");
        setAllAssignments([]);
        setTotalCount(0);
        setPage(1);
        toast.info("Filters reset", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
    };

    const handleEditClick = (assignment) => {
        setSelectedAssignment(assignment);
        setModalShow(true);
    };

    const totalPages = useMemo(() => {
        if (!totalCount || !limit) return 1;
        return Math.max(1, Math.ceil(totalCount / limit));
    }, [totalCount, limit]);

    const goToPage = async (nextPage) => {
        if (nextPage < 1 || nextPage > totalPages) return;

         if (!allAssignments.length && totalCount > 0) {
            const params = buildQueryParams(nextPage);
            const response = await fetchAssignmentsAdmin(params);
            if (response?.items) {
                setAssignments(response.items);
                setPage(nextPage);
            }
            return;
        }

          const start = (nextPage - 1) * limit;
        const end = start + limit;
        setAssignments(allAssignments.slice(start, end));
        setPage(nextPage);
    };

     const handleModalClose = () => {
        setModalShow(false);
         applyFilter();
    };

    return (
        <>
            <Card className="shadow-sm bg-light p-0">
                <Card.Body>

                    <div className="d-flex flex-wrap gap-2 mb-3 align-items-end justify-content-start">

                        <div style={{ minWidth: 120 }}>
                            <Dropdown onSelect={(value) => setStatus(value)}>
                                <Dropdown.Toggle variant="secondary" size="sm" style={{ width: "100%" }}>
                                    {status || "Status"}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    {statusOptions.map((option) => (
                                        <Dropdown.Item key={option} eventKey={option}>
                                            {option}
                                        </Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>

                        <div style={{ minWidth: 120 }}>
                            <Dropdown onSelect={(value) => setCheckStatus(value)}>
                                <Dropdown.Toggle variant="secondary" size="sm" style={{ width: "100%" }}>
                                    {checkStatus || "Check Status"}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    {checkStatusOptions.map((option) => (
                                        <Dropdown.Item key={option} eventKey={option}>
                                            {option}
                                        </Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>

                            <Button variant="success" size="sm" onClick={applyFilter}>
                                Apply
                            </Button>
                            <Button variant="outline-secondary" size="sm" onClick={resetFilters}>
                                Reset
                            </Button>
                            <AdminStaleAssignmentAudit onApplied={applyFilter} />

                        <div style={{ width: 90 }} className=" d-none d-md-block">
                            <InputGroup size="sm">
                                <InputGroup.Text>S</InputGroup.Text>
                                <Form.Control
                                    placeholder="Search.."
                                    value={q}
                                    onChange={(e) => setQ(e.target.value)}
                                />
                            </InputGroup>
                        </div>
                        <div style={{ minWidth: 120 }} className="d-none d-md-block">
                            <Form.Select
                                id="assTypeSelect"
                                value={assTypeId}
                                onChange={handleAssTypeChange}
                                style={{ width: "120px" }}
                                className="form-select-sm border border-success text-success"
                            >
                                <option value="">Type Filter...</option>
                                {assTypeOptions.map((type) => (
                                        <option key={type.filterValue} value={type.filterValue}>
                                            {type.filterLabel + '\u00A0'}
                                        </option>
                                    ))}
                            </Form.Select>
                        </div>

                        <div className="ms-3 me-2">
                            <small className="text-muted mb-0 d-none d-md-block">Link</small>
                            <Form.Check
                                type="switch"
                                id="only-with-link"
                                checked={onlyWithLink}
                                onChange={(e) => setOnlyWithLink(e.target.checked)}
                            />
                        </div>

                        <div className="d-block d-md-none">
                            <small className="text-muted mb-1 d-none d-block">PP</small>
                            <Form.Select
                                size="sm"
                                value={limit}
                                onChange={(e) => setLimit(Number(e.target.value))}
                                style={{ width: 60 }}
                            >
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                                <option value={200}>200</option>
                            </Form.Select>
                        </div>

                        <div className="d-flex flex-wrap align-items-end gap-1">

                            <div style={{ width: 50 }}>
                                <small className="text-muted mb-1 d-none d-md-block">Enter ID</small>
                                <Form.Control
                                    type="text"
                                    className="form-control-sm"
                                    placeholder="BID"
                                    value={bookId}
                                    onChange={(e) => setBookId(e.target.value)}
                                />

                            </div>
                            <div style={{ width: 50 }}>
                                <Form.Control
                                    type="text"
                                    className="form-control-sm"
                                    placeholder="RID"
                                    value={reviewerId}
                                    onChange={(e) => setReviewerId(e.target.value)}
                                />
                            </div>
                            <div style={{ width: 50 }}>
                                <Form.Control
                                    type="text"
                                    className="form-control-sm"
                                    placeholder="OID"
                                    value={ownerId}
                                    onChange={(e) => setOwnerId(e.target.value)}
                                />
                            </div>
                            <div style={{ width: 50 }}>
                                <Form.Control
                                    className="form-control-sm"
                                    placeholder="AID"
                                    value={assignmentId}
                                    onChange={(e) => setAssignmentId(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="d-none d-md-flex flex-nowrap align-items-end gap-3">
                            {/* Created */}
                            <div className="d-flex align-items-end gap-1">
                                <div>
                                    <small className="text-muted mb-1 d-block">Created</small>
                                    <Form.Control
                                        type="date"
                                        size="sm"
                                        value={createDate}
                                        onChange={(e) => setCreateDate(e.target.value)}
                                        style={{ width: 55 }}
                                    />
                                </div>
                                <div>
                                    <Form.Control
                                        type="date"
                                        size="sm"
                                        value={createDateTo}
                                        onChange={(e) => setCreateDateTo(e.target.value)}
                                        style={{ width: 55 }}
                                    />
                                </div>
                            </div>

                            {/* Start */}
                            <div className="d-flex align-items-end gap-1">
                                <div>
                                    <small className="text-muted mb-1 d-block">Start</small>
                                    <Form.Control
                                        type="date"
                                        size="sm"
                                        value={startDate}
                                        onChange={(e) => setStartDate(e.target.value)}
                                        style={{ width: 55 }}
                                    />
                                </div>
                                <div>
                                    <Form.Control
                                        type="date"
                                        size="sm"
                                        value={startDateTo}
                                        onChange={(e) => setStartDateTo(e.target.value)}
                                        style={{ width: 55 }}
                                    />
                                </div>
                            </div>

                            {/* Report */}
                            <div className="d-flex align-items-end gap-1">
                                <div>
                                    <small className="text-muted mb-1 d-block">Report</small>
                                    <Form.Control
                                        type="date"
                                        size="sm"
                                        value={publishDate}
                                        onChange={(e) => setPublishDate(e.target.value)}
                                        style={{ width: 55 }}
                                    />
                                </div>
                                <div>
                                    <Form.Control
                                        type="date"
                                        size="sm"
                                        value={publishDateTo}
                                        onChange={(e) => setPublishDateTo(e.target.value)}
                                        style={{ width: 55 }}
                                    />
                                </div>
                            </div>

                            {/* Confirmed */}
                            <div className="d-flex align-items-end gap-1">
                                <div>
                                    <small className="text-muted mb-1 d-block">Confirmed</small>
                                    <Form.Control
                                        type="date"
                                        size="sm"
                                        value={confirmDate}
                                        onChange={(e) => setConfirmDate(e.target.value)}
                                        style={{ width: 55 }}
                                    />
                                </div>
                                <div>
                                    <Form.Control
                                        type="date"
                                        size="sm"
                                        value={confirmDateTo}
                                        onChange={(e) => setConfirmDateTo(e.target.value)}
                                        style={{ width: 55 }}
                                    />
                                </div>
                            </div>
                        </div>


                        <div className="d-none d-md-block">
                            <small className="text-muted mb-1 d-block">PP</small>
                            <Form.Select
                                size="sm"
                                value={limit}
                                onChange={(e) => setLimit(Number(e.target.value))}
                                style={{ width: 60 }}
                            >
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                                <option value={200}>200</option>
                            </Form.Select>
                        </div>



                    </div>


                    {message && <p className="text-muted mt-3 text-center">{message}</p>}

                    {loading ? (
                        <div className="d-flex align-items-center gap-2">
                            <Spinner size="sm" /> <small>Loading...</small>
                        </div>
                    ) : (
                        <>
                    {assignments.length > 0 && (
                        <>
                            <div
                                style={{ overflowX: "auto", whiteSpace: "nowrap", paddingBottom: "10px" }}
                            >
                                <Table striped bordered hover size="sm" style={{ minWidth: "1200px" }}>
                                    <thead className="small">
                                    <tr className="small">
                                        <th>ID</th>
                                        <th>VE</th>
                                        <th>S</th>
                                        <th>Sp</th>
                                        <th>Status</th>
                                        <th>Step</th>
                                        <th>RID</th>
                                        <th>Reviewer</th>
                                        <th>PrR</th>
                                        <th>Bonus</th>
                                        <th>OID</th>
                                        <th>PrO</th>
                                        <th>RQ</th>
                                        <th>ID</th>
                                        <th>Title</th>
                                        <th>BT</th>
                                        <th>AT</th>
                                        <th>$</th>
                                        <th>Staff</th>
                                        <th>MTP</th>
                                        <th>R</th>
                                        <th>CR</th>
                                        <th>Link</th>
                                        <th>Create</th>
                                        <th>Take</th>
                                        <th>Report</th>
                                        <th>Confirm</th>
                                        <th>Check</th>
                                        <th>AID</th>

                                    </tr>
                                    </thead>
                                    <tbody>
                                    {assignments.map((assignment) => (
                                        <tr
                                            className="align-start small"
                                            key={assignment?.id}
                                            onClick={() => handleEditClick(assignment)}
                                        >
                                            <td className="text-start py-0 px-1 small">{assignment?.id}</td>
                                            <td className="text-start py-0 px-1 small">{assignment?.views || 0}</td>
                                            <td className="text-start py-0 px-1 small">{assignment?.strikes || 0}</td>
                                            <td className="text-start py-0 px-1 small">
                                                {assignment?.speed_up_level || "N/A"}
                                            </td>
                                            <td className="text-start py-0 px-1 small fw-bolder">
                                                {assignment?.assignment_status}
                                            </td>
                                            <td className="text-start py-0 px-1 small fw-bolder">
                                                {assignment?.reviewer_reading_step || "N/A"}
                                            </td>
                                            <td className="text-start py-0 px-1 small">{assignment?.reviewer_id}</td>
                                            <td className="text-start py-0 px-1 small">
                                                {assignment?.reviewer_name?.length > 15
                                                    ? assignment?.reviewer_name.substring(0, 15) + "..."
                                                    : assignment?.reviewer_name}
                                            </td>
                                            <td className="text-start py-0 px-1 small">
                                                {assignment?.assignment_price_reader || "N/A"}
                                            </td>
                                            <td className="text-start py-0 px-1 small">
                                                {assignment?.received_bonus || "N/A"}
                                            </td>
                                            <td className="text-start py-0 px-1 small">{assignment?.userId}</td>
                                            <td className="text-start py-0 px-1 small">
                                                {assignment?.assignment_price_publisher || "N/A"}
                                            </td>
                                            <td className="text-start py-0 px-1 small">
                                                {assignment?.rating_of_reviewer || "N/A"}
                                            </td>
                                            <td className="text-start py-0 px-1 small">{assignment?.bookId}</td>
                                            <td className="text-start py-0 px-1 small">
                                                {assignment?.book?.title?.length > 15
                                                    ? assignment?.book?.title.substring(0, 12) + "."
                                                    : assignment?.book?.title}
                                            </td>
                                            <td className="text-start py-0 px-1 small">
                                                {assignment?.booksTypeId === 1 && "K"}
                                                {assignment?.booksTypeId === 2 && "P"}
                                                {assignment?.booksTypeId === 3 && "H"}
                                                {assignment?.booksTypeId === 4 && "A"}
                                                {assignment?.booksTypeId === 5 && "B"}
                                                {assignment?.booksTypeId === 6 && "R"}
                                                {assignment?.booksTypeId === 7 && "PrT1"}
                                                {assignment?.booksTypeId === 8 && "PrT2"}
                                                {assignment?.booksTypeId === 9 && "PrT3"}
                                                {assignment?.booksTypeId === 10 && "PrT4"}
                                            </td>
                                            <td className="text-start py-0 px-1 small">
                                                {assignment?.assTypeId === 1 && "Uni"}
                                                {assignment?.assTypeId === 2 && "KU"}
                                                {assignment?.assTypeId === 3 && "VP"}
                                                {assignment?.assTypeId === 4 && "VP Img"}
                                                {assignment?.assTypeId === 5 && "VP S&B"}
                                                {assignment?.assTypeId === 6 && "VP S&B Img"}
                                                {assignment?.assTypeId === 7 && "Uni Audio"}
                                                {assignment?.assTypeId === 8 && "Audible PC"}
                                                {assignment?.assTypeId === 9 && "Verified KU"}
                                                {assignment?.assTypeId === 10 && "PB BuyOut"}
                                                {assignment?.assTypeId === 11 && "PB S&B"}
                                                {assignment?.assTypeId === 12 && "PB VP Img"}
                                                {assignment?.assTypeId === 13 && "PB VP Video"}
                                                {assignment?.assTypeId === 14 && "HC BuyOut"}
                                                {assignment?.assTypeId === 15 && "HC S&B"}
                                                {assignment?.assTypeId === 16 && "HC VP Img"}
                                                {assignment?.assTypeId === 17 && "HC VP Video"}
                                                {assignment?.assTypeId === 18 && "PB VP"}
                                                {assignment?.assTypeId === 19 && "PB VP S&B"}
                                                {assignment?.assTypeId === 20 && "HC VP"}
                                                {assignment?.assTypeId === 21 && "HC VP S&B"}
                                                {assignment?.assTypeId === 22 && "Prod BuyOut"}
                                                {assignment?.assTypeId === 23 && "Prod S&BO"}
                                                {assignment?.assTypeId === 24 && "Prod VP"}
                                                {assignment?.assTypeId === 25 && "Prod VP Img"}
                                                {assignment?.assTypeId === 26 && "Prod VP Video"}
                                                {assignment?.assTypeId === 27 && "Prod VP S&B"}
                                                {assignment?.assTypeId === 28 && "Boost Rew"}
                                                {assignment?.assTypeId === 29 && "Report Rev"}
                                                {assignment?.assTypeId === 30 && "Boost Ext"}
                                                {assignment?.assTypeId === 31 && "Report Ext"}
                                                {assignment?.assTypeId === 32 && "Set Stars Rating"}

                                            </td>
                                            <td className="text-start py-0 px-1 small">
                                                {assignment?.book_cost_compensation != null && assignment?.book_cost_compensation !== ""
                                                    ? `$${(+assignment.book_cost_compensation).toFixed(2)}`
                                                    : assignment?.booksPriceId === 1 ? "FREE"
                                                        : assignment?.booksPriceId === 2 ? "$0.99"
                                                            : assignment?.booksPriceId === 3 ? "$1.99"
                                                                : assignment?.booksPriceId === 4 ? "$2.99"
                                                                    : assignment?.booksPriceId === 5 ? "$3.99"
                                                                        : assignment?.booksPriceId === 6 ? "$4.99"
                                                                            : assignment?.booksPriceId === 7 ? "$5.99"
                                                                                : assignment?.booksPriceId === 8 ? "$6.99"
                                                                                    : assignment?.booksPriceId === 9 ? "$7.99"
                                                                                        : assignment?.booksPriceId === 10 ? "$8.99"
                                                                                            : assignment?.booksPriceId === 11 ? "$9.99"
                                                                                    : ""}
                                            </td>
                                            <td className="text-center py-0 px-0 small">
                                                <Badge bg={hasValue(assignment?.review_link_staff_comment) ? "danger" : "info"}>
                                                    {hasValue(assignment?.review_link_staff_comment) ? "!!!" : "OK"}
                                                </Badge>
                                            </td>
                                            <td className="text-center py-0 px-0 small">
                                                <Badge bg={hasValue(assignment?.message_to_publisher) ? "danger" : "info"}>
                                                    {hasValue(assignment?.message_to_publisher) ? "???" : "OK"}
                                                </Badge>
                                            </td>
                                            <td className="text-start py-0 px-1 small">{assignment?.rating || "N/A"}</td>
                                            <td className="text-start py-0 px-1 small">
                                                {assignment?.checked_review_rating || "N/A"}
                                            </td>
                                            <td className="text-start py-0 px-1 small">
                                                {hasValue(assignment?.review_link) ? (
                                                    <span className="badge bg-success">YES</span>
                                                ) : (
                                                    "N/A"
                                                )}
                                            </td>
                                            <td className="text-start py-0 px-1 small">
                                                {formatDateWithElapsedTime(assignment?.start_rev_date)}
                                            </td>
                                            <td className="text-start py-0 px-1 small">
                                                {formatDateWithElapsedTime(assignment?.start_read_date)}
                                            </td>
                                            <td className="text-start py-0 px-1 small">
                                                {formatDateWithElapsedTime(assignment?.publish_rev_date)}
                                            </td>
                                            <td className="text-start py-0 px-1 small">
                                                {formatDateWithElapsedTime(assignment?.end_rev_date)}
                                            </td>
                                            <td className="text-center py-0 px-0 small">
                                                {assignment?.check_status}
                                            </td>
                                            <td className="text-center py-0 px-0 small">
                                                {assignment?.amz_review_id}
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </Table>
                            </div>

                            <div className="d-flex justify-content-between align-items-center">
                                <div className="small text-muted">
                                    Total: {totalCount} Assignments, Page {page} of {totalPages}
                                </div>
                                <Pagination size="sm" className="mb-0">
                                    <Pagination.Prev onClick={() => goToPage(page - 1)} disabled={page <= 1} />
                                    <Pagination.Item active>{page}</Pagination.Item>
                                    <Pagination.Next
                                        onClick={() => goToPage(page + 1)}
                                        disabled={page >= totalPages}
                                    />
                                </Pagination>

                            </div>
                        </>
                    )}
                        </>
                        )}
                </Card.Body>
            </Card>

            {/* РњРѕРґР°Р»СЊРЅРѕРµ РѕРєРЅРѕ СЂРµРґР°РєС‚РёСЂРѕРІР°РЅРёСЏ */}
            {selectedAssignment && (
                <EditAssignmentAdmin
                    key={selectedAssignment.id}
                    show={modalShow}
                    handleClose={handleModalClose}
                    initialAssignmentFromTable={selectedAssignment}
                    statusin={selectedAssignment.assignment_status}
                    stepin={selectedAssignment.reviewer_reading_step}
                    onOpenBookAssignments={onOpenBookAssignments}
                    onOpenUserAuthorAssignments={onOpenUserAuthorAssignments}
                    onOpenUserReviewerAssignments={onOpenUserReviewerAssignments}
                />
            )}
        </>
    );
};

export default AssignmentSearch;
